module.exports = __webpack_public_path__ + "static/media/Team 10 - Logos.b98661eb.png";